import { createStore } from 'vuex';
import Cookies from 'js-cookie';

const cookieOptions = {
  expires: 7,
  sameSite: 'Lax',
  secure: process.env.NODE_ENV === 'production',
  path: '/'
};

export default createStore({
  state: {
    cart: JSON.parse(Cookies.get('cart') || '[]'),
    auth: {
      token: localStorage.getItem('accessToken') || null,
      username: localStorage.getItem('username') || '',
      isAdmin: localStorage.getItem('isAdmin') === 'true',
      userId: localStorage.getItem('userId') || null,
      userEmail: localStorage.getItem('userEmail') || '',
    }
  },
  getters: {
    cartCount: (state) => {
      return state.cart.reduce((total, item) => total + item.quantity, 0);
    },
    cartTotal: (state) => {
      return state.cart.reduce((total, item) => total + (item.price * item.quantity), 0);
    },
    cartItems: (state) => state.cart,
    isCartOpen: (state) => state.isCartOpen,
    
    // Auth getters
    isAuthenticated: (state) => !!state.auth.token,
    currentUsername: (state) => state.auth.username,
    isAdmin: (state) => state.auth.isAdmin,
    userId: (state) => state.auth.userId,
    userEmail: (state) => state.auth.userEmail,
  },
  mutations: {
    // Existing cart mutations
    ADD_TO_CART(state, item) {
      const existingItem = state.cart.find(i => i.id === item.id && i.blister_id === item.blister_id);
      if (existingItem) {
        existingItem.quantity += item.quantity || 1;
      } else {
        state.cart.push({
          id: item.id,
          blister_id: item.blister_id,
          name: item.name,
          price: item.price,
          brand: item.brand,
          image: item.image,
          quantity: item.quantity || 1
        });
      }
      Cookies.set('cart', JSON.stringify(state.cart), cookieOptions);
    },
    REMOVE_FROM_CART(state, productId) {
      state.cart = state.cart.filter(item => item.id !== productId);
      Cookies.set('cart', JSON.stringify(state.cart), cookieOptions);
    },
    UPDATE_QUANTITY(state, { productId, quantity }) {
      const product = state.cart.find(item => item.id === productId);
      if (product) {
        product.quantity = Math.max(0, quantity);
        if (product.quantity === 0) {
          state.cart = state.cart.filter(item => item.id !== productId);
        }
      }
      Cookies.set('cart', JSON.stringify(state.cart), cookieOptions);
    },
    CLEAR_CART(state) {
      state.cart = [];
      Cookies.remove('cart', cookieOptions);
    },
    
    // Auth mutations
    SET_AUTH_USER(state, { token, username, isAdmin, userId, userEmail }) {
      state.auth.token = token;
      state.auth.username = username;
      state.auth.isAdmin = isAdmin;
      state.auth.userId = userId || null;
      state.auth.userEmail = userEmail || '';
      
      // Also update localStorage
      localStorage.setItem('accessToken', token);
      localStorage.setItem('username', username);
      localStorage.setItem('isAdmin', isAdmin ? 'true' : 'false');
      if (userId) localStorage.setItem('userId', userId);
      if (userEmail) localStorage.setItem('userEmail', userEmail);
    },
    CLEAR_AUTH(state) {
      state.auth.token = null;
      state.auth.username = '';
      state.auth.isAdmin = false;
      state.auth.userId = null;
      state.auth.userEmail = '';
      
      // Clear localStorage auth data
      localStorage.removeItem('accessToken');
      localStorage.removeItem('username');
      localStorage.removeItem('isAdmin');
      localStorage.removeItem('userId');
      localStorage.removeItem('userEmail');
    }
  },
  actions: {
    // Existing cart actions
    addToCart({ commit }, product) {
      commit('ADD_TO_CART', product);
    },
    removeFromCart({ commit }, productId) {
      commit('REMOVE_FROM_CART', productId);
    },
    updateQuantity({ commit }, payload) {
      commit('UPDATE_QUANTITY', payload);
    },
    clearCart({ commit }) {
      commit('CLEAR_CART');
    },
    
    // Auth actions
    setAuthUser({ commit }, userData) {
      commit('SET_AUTH_USER', userData);
    },
    logout({ commit }) {
      commit('CLEAR_AUTH');
    }
  }
});